module.exports = __webpack_public_path__ + "static/media/card-open-claw-mobile-es.7d0dd219.png";